import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Col,
  Row,
  Input,
  Label,
  Button,
  Collapse,
} from "reactstrap";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";
// select
import Select from "react-select";
// cor
import ColorPicker from "../../../components/ColorPicker/ColorPicker";
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
//react router dom
import { useLocation } from "react-router-dom";
// service
import {
  createConfigApp,
  getConfigApp,
} from "../../../utils/services/configApp";
import { getUrlFiles } from "../../../utils/services/files";
import { getMobileApps } from "../../../utils/services/mobileApps";
import {
  updateEventPartial,
  getEventByEvent,
} from "../../../utils/services/events";
import {
  getConfigLogistics,
  changeConfigLogistics,
} from "../../../utils/services/configLogistics";
import { getGroups } from "../../../utils/services/group";
//redux
import { connect } from "react-redux";

const IMAGES_TOO_LARGE_MESSAGE =
  "Os dados inseridos estão muito grandes, verifique o tamanho das imagens!";

function ModalConfigApp(props) {
  const { toggle, isOpen, eventId, jwt = "" } = props;
  const location = useLocation();
  // dados do form
  const [mobileapps, setMobileApps] = useState([]);
  const [mobileappsMulti, setMobileAppsMulti] = useState([]);
  const [color, setColor] = useState("#ffffff");
  const [numberColum, setNumberColum] = useState(0);
  const [imageBackground, setImageBackground] = useState("");
  const [image, setImage] = useState("");
  const [menuLogo, setMenuLogo] = useState("");
  const [hideCredential, setHideCredential] = useState(false);
  const [hideLocation, setHideLocation] = useState(false);
  const [showCompany, setShowCompany] = useState(false);
  const [showOffice, setShowOffice] = useState(false);
  // cor interna do evento (menu horizontal e seus topos)
  const [enableInternalColor, setEnableInternalColor] = useState(false);
  const [menuAndHeadersColor, setMenuAndHeadersColor] = useState("#ffffff");
  // dados das cores de logistica
  const [vooColorCard, setVooColorCard] = useState("#ffffff");
  const [vooColorText, setVooColorText] = useState("#ffffff");
  const [transferColorCard, setTransferColorCard] = useState("#ffffff");
  const [transferColorText, setTransferColorText] = useState("#ffffff");
  const [hotelColorCard, setHotelColorCard] = useState("#ffffff");
  const [hotelColorText, setHotelColorText] = useState("#ffffff");
  const [typeRequestLogistic, setTypeRequestLogistic] = useState("post");
  const [idConfigLogistic, setIdConfigLogistic] = useState(null);
  // evento selecionado
  const [idThisEvent, setIdThisEvent] = useState(null);
  // imgs para visualização
  const [imageBackgroundView, setImageBackgroundView] = useState();
  const [imageView, setImageView] = useState();
  const [imageLogoView, setImageLogoView] = useState();
  // erros
  const [appsEventError, setAppsEventError] = useState("");
  const [numberColumnError, setNumberColumnError] = useState("");
  const [imageError, setImageError] = useState("");
  const [vooError, setVooError] = useState("");
  const [transferError, setTransferError] = useState("");
  const [hotelError, setHotelError] = useState("");
  // alerta
  const [successAlert, setSuccessAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState(IMAGES_TOO_LARGE_MESSAGE);
  // tipo de requisição e dados da config criada
  const [typeRequest, setTypeRequest] = useState("");
  const [idConfig, setIdConfig] = useState(null);
  // carregamento do form
  const [loadingForm, setLoadingForm] = useState(true);
  const [isLoading, setIsloading] = useState(false);
  // drop
  const [dropLogistics, setDropLogistics] = useState(false);
  const [dropConfigScreen, setDropConfigScreen] = useState(false);
  // form da sessão configurar tela
  const [enebleScreen, setEnabelScreen] = useState(false);
  const [formConfigScreen, setFormConfigScreen] = useState({});
  const [errosConfigScreen, setErrosConfigScreen] = useState({});
  // grupos
  const [groups, setGroups] = useState([]);

  function handleMobiAppsMulti(a) {
    setMobileAppsMulti(a);
  }

  function verifyForm() {
    setErrosConfigScreen({});

    if (!mobileappsMulti[0]) {
      setAppsEventError("Selecione ao menos um Aplicativo do Evento");
      return;
    } else setAppsEventError("");

    if (!numberColum || numberColum < 1) {
      setNumberColumnError("O campo Quantidade de Colunas é obrigatório");
      return;
    } else setNumberColumnError("");

    if (!image && !imageView) {
      setImageError("Selecione uma imagem para o evento");
      return;
    } else setImageError("");

    if (vooColorCard === vooColorText) {
      setVooError("As cores de card e texto não podem ser iguais");
      setDropLogistics(true);
      return;
    } else setVooError("");

    if (transferColorCard === transferColorText) {
      setTransferError("As cores de card e texto não podem ser iguais");
      setDropLogistics(true);
      return;
    } else setTransferError("");

    if (hotelColorCard === hotelColorText) {
      setHotelError("As cores de card e texto não podem ser iguais");
      setDropLogistics(true);
      return;
    } else setHotelError("");

    if (enebleScreen && !formConfigScreen.url) {
      setErrosConfigScreen({
        url: "Esse campo é obrigatório",
      });
      setDropConfigScreen(true);
      return;
    }

    if (enebleScreen && !formConfigScreen.title) {
      setErrosConfigScreen({
        title: "Esse campo é obrigatório",
      });
      setDropConfigScreen(true);
      return;
    }

    if (enebleScreen && formConfigScreen.facial && !formConfigScreen.idMice) {
      setErrosConfigScreen({
        idMice: "Esse campo é obrigatório",
      });
      setDropConfigScreen(true);
      return;
    }

    submitForm();
  }

  async function submitForm() {
    let urlEventImg = imageView;
    let expireDateEventImg = null;

    let urlBackGroundImage = imageBackgroundView;
    let expireDateBackGroundImage = null;

    let urlLogoMenu = imageLogoView;
    let expireDateLogoMenu = null;

    var data = new FormData();

    var haveImg = false;

    if (image && image?.target?.files[0]) {
      data.append("files", image.target.files[0]);
      haveImg = true;
    }
    if (imageBackground && imageBackground?.target?.files[0]) {
      data.append("files", imageBackground.target.files[0]);
      haveImg = true;
    }
    if (menuLogo && menuLogo?.target?.files[0]) {
      data.append("files", menuLogo.target.files[0]);
      haveImg = true;
    }
    data.append("folder", "event");
    data.append("eventId", eventId);

    if (haveImg) {
      try {
        const response = await getUrlFiles(
          data,
          props.state.global_user_data.data.token,
        );
        response.forEach((e) => {
          if (e.name === image?.target?.files[0]?.name) {
            urlEventImg = e.url;
            expireDateEventImg = e.expires;
          }
          if (e.name === imageBackground?.target?.files[0]?.name) {
            urlBackGroundImage = e.url;
            expireDateBackGroundImage = e.expires;
          }
          if (e.name === menuLogo?.target?.files[0]?.name) {
            urlLogoMenu = e.url;
            expireDateLogoMenu = e.expires;
          }
        });
      } catch (error) {
        console.error("Erro ao enviar as imagens:", error);
        setErrorMessage(IMAGES_TOO_LARGE_MESSAGE);
        setErrorAlert(true);
        return;
      }
    }

    var mobileAppsArray = [];

    mobileappsMulti.forEach((e) => mobileAppsArray.push(e.value));

    const dataForm = {
      eventId: eventId,
      image: urlEventImg,
      backgroundColorMenu: color,
      menuLogo:
        urlLogoMenu === undefined || urlLogoMenu === null ? "" : urlLogoMenu,
      numberColumns: numberColum,
      backgroundImageMenu:
        urlBackGroundImage === undefined || urlBackGroundImage === null
          ? ""
          : urlBackGroundImage,
      hideCredential: hideCredential,
      hideLocation: hideLocation,
      expireDateImgEvent: expireDateEventImg,
      expireDateImgBackground: expireDateBackGroundImage,
      expireDateImgMenuLogo: expireDateLogoMenu,
      mobileApps: mobileAppsArray,
      miceEventId:
        enebleScreen && formConfigScreen.facial ? formConfigScreen.idMice : "",
      enablePostLoginScreen: enebleScreen,
      enablePostLoginFaceCapture: enebleScreen
        ? formConfigScreen.facial
        : false,
      urlPostLoginScreen: enebleScreen ? formConfigScreen.url : "",
      allowSkipPostLoginScreen: enebleScreen
        ? formConfigScreen.skipScreen
        : false,
      showModalPostLoginScreen: enebleScreen
        ? formConfigScreen.showModal
        : false,
      groupsIgnorePostLoginScreen:
        enebleScreen &&
        formConfigScreen &&
        formConfigScreen.groups &&
        formConfigScreen.groups.length > 0
          ? formConfigScreen.groups.map((group) => group.value)
          : [],
      titleScreen: enebleScreen ? formConfigScreen.title : "",
      enableInternalEventColor: enableInternalColor,
      menuAndHeadersColor: enableInternalColor ? menuAndHeadersColor : null,
    };

    try {
      setIsloading(true);
      const res = await createConfigApp(dataForm, jwt, typeRequest, idConfig);

      setIsloading(false);
      if (res.data.message === "created" || res.data.message === "updated") {
        submitFormLogistics();
      }
    } catch (error) {
      setIsloading(false);
      console.error("Erro ao salvar configuração do app:", error);
      setErrorMessage(
        error?.response?.data?.message ||
          "Erro ao salvar as configurações do aplicativo.",
      );
      setErrorAlert(true);
    }
  }

  async function submitFormLogistics() {
    const data = {
      eventId: eventId,
      flightCardColor: vooColorCard,
      flightFontColor: vooColorText,
      hotelCardColor: hotelColorCard,
      hotelFontColor: hotelColorText,
      transferCardColor: transferColorCard,
      transferFontColor: transferColorText,
    };

    try {
      const res = await changeConfigLogistics(
        data,
        typeRequestLogistic,
        idConfigLogistic,
      );

      if (res?.message === "created" || res?.message === "updated") {
        editEvent();
      }
    } catch (error) {
      console.error("Erro ao salvar configuração de logística:", error);
      setErrorMessage("Erro ao salvar configuração de logística.");
      setErrorAlert(true);
    }
  }

  async function editEvent() {
    try {
      const data = {
        showCompany: showCompany,
        showJobPosition: showOffice,
      };

      const res = await updateEventPartial(data, eventId);

      if (res.message === "event updated") {
        setSuccessAlert(true);
      }
    } catch (error) {
      console.error("Erro ao atualizar o evento:", error);
      setErrorMessage("Erro ao atualizar o evento.");
      setErrorAlert(true);
    }
  }

  async function getMobileAppEvent() {
    await getMobileApps({
      jwt: props.state.global_user_data?.data.token,
      offset: 1,
      limit: 100,
      search: "",
      contractId: props.state.global_user_data.data.theme[0].id,
    }).then((response) => {
      setMobileApps(response.findAllMobileAppData.data);
    });
  }

  async function verifyConfigApp() {
    await getConfigApp(eventId, jwt)
      .then(async (res) => {
        if (res.data.findAllMobileAppData.count > 0) {
          setTypeRequest("put");
          const config = res.data.findAllMobileAppData.data[0];

          var appsSelected = [];

          config.app.forEach((e) => {
            appsSelected.push({
              label: e.name,
              value: e.id,
            });
          });

          setColor(config.backgroundColorMenu);
          setNumberColum(config.numberColumns);
          setImageBackgroundView(config.backgroundImageMenu);
          setImageView(config.image);
          setImageLogoView(config.menuLogo);
          setHideCredential(config.hideCredential);
          setHideLocation(config.hideLocation);
          setIdConfig(config.id);
          setEnabelScreen(config.enablePostLoginScreen);
          setEnableInternalColor(config.enableInternalEventColor ?? false);
          setMenuAndHeadersColor(config.menuAndHeadersColor ?? "#ffffff");
          setFormConfigScreen({
            url: config.urlPostLoginScreen,
            title: config.titleScreen,
            skipScreen: config.allowSkipPostLoginScreen,
            showModal: config.showModalPostLoginScreen,
            facial: config.enablePostLoginFaceCapture,
            idMice: config.miceEventId,
          });

          handleMobiAppsMulti(appsSelected);
        } else setTypeRequest("post");

        await getGroupsFunc(
          res?.data?.findAllMobileAppData?.data[0]?.groupsIgnorePostLoginScreen,
        );

        getDataEvent();
      })
      .catch((error) => {
        console.error("Erro ao buscar configuração do app:", error);
        toast.error("Erro ao buscar configuração do app.");
        setLoadingForm(false);
      });
  }

  async function getDataEvent() {
    await getEventByEvent(eventId)
      .then((res) => {
        if (res.message === "findEventoById") {
          setShowCompany(res.data.showCompany);
          setShowOffice(res.data.showJobPosition);
        }
      })
      .catch((error) => console.log("event erro", error));

    getConfigLogistic();
  }

  async function getConfigLogistic() {
    try {
      const res = await getConfigLogistics(eventId);

      if (
        res?.message === "getLogisticsConfig" &&
        res?.getLogisticsConfig?.data[0]
      ) {
        const data = res.getLogisticsConfig.data[0];

        setTypeRequestLogistic("put");
        setVooColorCard(data.flightCardColor);
        setVooColorText(data.flightFontColor);
        setTransferColorCard(data.transferCardColor);
        setTransferColorText(data.transferFontColor);
        setHotelColorCard(data.hotelCardColor);
        setHotelColorText(data.hotelFontColor);
        setIdConfigLogistic(data.id);
      }
    } catch (error) {
      console.error("Erro ao buscar configuração de logística:", error);
      toast.error("Erro ao buscar configuração de logística.");
    } finally {
      setLoadingForm(false);
    }
  }

  function checkItemMenuExists(menuOption) {
    return (
      props.state.global_user_data.data.foundProducts.filter(
        (item) => item.name === menuOption,
      ).length > 0
    );
  }

  async function getGroupsFunc(groupsSaved) {
    await getGroups({
      jwt: "",
      eventId: eventId,
      offset: 1,
      limit: 0,
      search: "",
    })
      .then((response) => {
        const groupsApi = response.findOneGroupData.data;

        setGroups(groupsApi);

        if (groupsSaved?.length > 0 && groupsApi?.length > 0) {
          const savedGroups = groupsApi
            .filter((e) => groupsSaved.includes(e.id))
            .map((e) => ({ label: e.name, value: e.id }));

          setFormConfigScreen((prev) => ({ ...prev, groups: savedGroups }));
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar grupos:", error);
        toast.error("Erro ao buscar os grupos.");
      });
  }

  useEffect(() => {
    verifyConfigApp();
    getMobileAppEvent();
  }, []);

  return (
    <>
      {successAlert && (
        <SweetAlert
          success
          title={"Concluído"}
          onConfirm={() => {
            toggle();
          }}
        >
          {"Configurações salvas com sucesso!"}
        </SweetAlert>
      )}

      {errorAlert && (
        <SweetAlert
          danger
          title={"Erro"}
          onConfirm={() => {
            setErrorAlert(false);
          }}
        >
          {errorMessage}
        </SweetAlert>
      )}
      <Modal isOpen={isOpen} centered autoFocus>
        <ModalHeader toggle={toggle}>Configurar APP</ModalHeader>
        {loadingForm ? (
          <p style={{ textAlign: "center" }}>Carregando ...</p>
        ) : (
          <div>
            <ModalBody>
              <Row style={{ marginTop: 10 }}>
                <Col lg={12}>
                  <div>
                    <label className="form-label">
                      Aplicativo(s) do Evento*
                    </label>
                    <Select
                      value={mobileappsMulti}
                      placeholder={"Selecione"}
                      isMulti={true}
                      onChange={(e) => {
                        handleMobiAppsMulti(e);
                      }}
                      options={[
                        {
                          options: [
                            ...mobileapps.map((e) => {
                              return { label: e.name, value: e.id };
                            }),
                          ],
                        },
                      ]}
                      classNamePrefix="select2-selection"
                    />
                    {appsEventError && (
                      <p style={{ color: "red" }}>{appsEventError}</p>
                    )}
                  </div>
                </Col>
              </Row>

              <Row>
                <ColorPicker
                  classOfContainer="bg-new-event-menu-pickr"
                  labelText="Cor de Fundo (Menu)"
                  setStateFunc={setColor}
                  defaultColor={color}
                />
              </Row>

              <Row style={{ marginTop: 10 }}>
                <Col md={12}>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="checkInternalColor"
                      checked={enableInternalColor}
                      onChange={(e) => setEnableInternalColor(e.target.checked)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="checkInternalColor"
                    >
                      Alterar cor interna do evento (Menu horizontal e topo das
                      telas Acesso, Alertas, Perfil)
                    </label>
                  </div>
                </Col>
              </Row>

              {enableInternalColor && (
                <Row>
                  <ColorPicker
                    classOfContainer="menu-and-headers-color-pickr"
                    labelText="Cor do menu e do topo das telas"
                    setStateFunc={setMenuAndHeadersColor}
                    defaultColor={menuAndHeadersColor}
                  />
                </Row>
              )}
              <Row>
                <Col lg={12}>
                  <div className="mt-3">
                    <label className="form-label">
                      Quantidade de Colunas - Max 3 (Menu)*
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      onChange={(e) => {
                        if (Number(e.target.value) <= 3) {
                          setNumberColum(e.target.value);
                        } else setNumberColum(3);
                      }}
                      value={numberColum}
                    />
                    {numberColumnError && (
                      <p style={{ color: "red" }}>{numberColumnError}</p>
                    )}
                  </div>
                </Col>
              </Row>
              <Row style={{ marginBottom: 10 }}>
                <Col sm={imageView && !image ? 6 : 12}>
                  <div>
                    <Label htmlFor="formFile" className="form-label">
                      Imagem do Evento*
                    </Label>
                    <Input
                      className="form-control"
                      type="file"
                      id="formFile"
                      defaultValue={null}
                      onChange={(e) => setImage(e)}
                    />
                    {imageError && <p style={{ color: "red" }}>{imageError}</p>}
                  </div>
                </Col>

                {imageView && !image && (
                  <Col md={6}>
                    <img src={imageView} style={{ width: 100, height: 100 }} />
                  </Col>
                )}
              </Row>

              <Row style={{ marginBottom: 20 }}>
                <Col sm={imageLogoView && !menuLogo ? 6 : 12}>
                  <div>
                    <Label
                      htmlFor="formFile"
                      className="form-label"
                      style={{ marginBottom: "0px" }}
                    >
                      Imagem do Menu
                    </Label>
                    <div
                      className="form-label"
                      style={{ marginTop: "-1px", fontSize: "11px" }}
                    >
                      *Utilize essa opção para diferenciar a imagem exibida no
                      topo do menu da imagem do evento.
                    </div>
                    <Input
                      className="form-control"
                      type="file"
                      id="formFile"
                      defaultValue={null}
                      onChange={(e) => setMenuLogo(e)}
                    />
                  </div>
                </Col>

                {imageLogoView && !menuLogo && (
                  <Col md={6}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={imageLogoView}
                        style={{ width: 100, height: 100 }}
                      />
                      <i
                        className="mdi mdi-trash-can icon-trash"
                        onClick={() => {
                          setImageLogoView(null);
                          setMenuLogo(null);
                        }}
                      />
                    </div>
                  </Col>
                )}
              </Row>

              <Row style={{ marginBottom: 10 }}>
                <Col md={imageBackgroundView && !imageBackground ? 6 : 12}>
                  <div>
                    <Label htmlFor="formFile" className="form-label">
                      Imagem de fundo dos botões do Menu
                    </Label>
                    <Input
                      className="form-control"
                      type="file"
                      id="formFile"
                      defaultValue={null}
                      onChange={(e) => setImageBackground(e)}
                    />
                  </div>
                </Col>

                {imageBackgroundView && !imageBackground && (
                  <Col md={6}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={imageBackgroundView}
                        style={{ width: 100, height: 100 }}
                      />
                      <i
                        className="mdi mdi-trash-can icon-trash"
                        onClick={() => {
                          setImageBackgroundView(null);
                          setImageBackground(null);
                        }}
                      />
                    </div>
                  </Col>
                )}
              </Row>

              <Row style={{ marginBottom: 20 }}>
                <Col md={6}>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      defaultChecked={hideCredential}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setHideCredential(true);
                        } else setHideCredential(false);
                      }}
                      id="checkAccreditationEvent"
                    />
                    <label
                      className="form-check-label"
                      htmlFor="checkAccreditationEvent"
                    >
                      Ocultar Credencial
                    </label>
                  </div>
                </Col>

                {location?.state?.event?.eventFormat != "digital" && (
                  <Col md={6}>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        defaultChecked={hideLocation}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setHideLocation(true);
                          } else setHideLocation(false);
                        }}
                        id="checkLocalizationEvent"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="checkLocalizationEvent"
                      >
                        Ocultar Localização
                      </label>
                    </div>
                  </Col>
                )}
              </Row>

              <Row>
                <Col md={12}>
                  <Label htmlFor="formFile" className="form-label">
                    Permitir edição dos campos Empresa e Cargo no Editar Perfil?
                  </Label>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      defaultChecked={showCompany}
                      id="checkCompany"
                      onChange={(e) => setShowCompany(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="checkCompany">
                      Exibir Empresa
                    </label>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      defaultChecked={showOffice}
                      id="checkOffice"
                      onChange={(e) => setShowOffice(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="checkOffice">
                      Exibir Cargo
                    </label>
                  </div>
                </Col>
              </Row>

              {(checkItemMenuExists("VOO") ||
                checkItemMenuExists("TRANSFER") ||
                checkItemMenuExists("HOTEL")) && (
                <>
                  <Row style={{ marginTop: 10 }}>
                    <SectionComponent
                      sectionName={"Configurar Logística"}
                      setIsOpen={setDropLogistics}
                      isOpen={dropLogistics}
                    />
                  </Row>

                  <Collapse isOpen={dropLogistics}>
                    {checkItemMenuExists("VOO") && (
                      <>
                        <label
                          style={{ marginBottom: 0 }}
                          className="form-label"
                        >
                          Voo
                        </label>
                        <Row style={{ marginBottom: 20 }}>
                          <Col md={6}>
                            <ColorPicker
                              classOfContainer="vooColorCard"
                              labelText="Cor do Card"
                              setStateFunc={setVooColorCard}
                              defaultColor={vooColorCard}
                              idDiv={"vooColorCard"}
                            />
                          </Col>

                          <Col md={6}>
                            <ColorPicker
                              classOfContainer="vooColorText"
                              labelText="Cor do Texto"
                              setStateFunc={setVooColorText}
                              defaultColor={vooColorText}
                              idDiv={"vooColorText"}
                            />
                          </Col>
                          {vooError && (
                            <a style={{ color: "red" }}>{vooError}</a>
                          )}
                        </Row>
                      </>
                    )}

                    {checkItemMenuExists("TRANSFER") && (
                      <>
                        <label
                          style={{ marginBottom: 0 }}
                          className="form-label"
                        >
                          Transfer
                        </label>
                        <Row style={{ marginBottom: 20 }}>
                          <Col md={6}>
                            <ColorPicker
                              classOfContainer="transferColorCard"
                              labelText="Cor do Card"
                              setStateFunc={setTransferColorCard}
                              defaultColor={transferColorCard}
                              idDiv={"transferColorCard"}
                            />
                          </Col>

                          <Col md={6}>
                            <ColorPicker
                              classOfContainer="transferColorText"
                              labelText="Cor do Texto"
                              setStateFunc={setTransferColorText}
                              defaultColor={transferColorText}
                              idDiv={"transferColorText"}
                            />
                          </Col>
                          {transferError && (
                            <a style={{ color: "red" }}>{transferError}</a>
                          )}
                        </Row>
                      </>
                    )}

                    {checkItemMenuExists("HOTEL") && (
                      <>
                        <label
                          style={{ marginBottom: 0 }}
                          className="form-label"
                        >
                          Hotel
                        </label>
                        <Row>
                          <Col md={6}>
                            <ColorPicker
                              classOfContainer="hotelColorCard"
                              labelText="Cor do Card"
                              setStateFunc={setHotelColorCard}
                              defaultColor={hotelColorCard}
                              idDiv={"hotelColorCard"}
                            />
                          </Col>

                          <Col md={6}>
                            <ColorPicker
                              classOfContainer="hotelColorText"
                              labelText="Cor do Texto"
                              setStateFunc={setHotelColorText}
                              defaultColor={hotelColorText}
                              idDiv={"hotelColorText"}
                            />
                          </Col>
                          {hotelError && (
                            <a style={{ color: "red" }}>{hotelError}</a>
                          )}
                        </Row>
                      </>
                    )}
                  </Collapse>
                </>
              )}

              <Row style={{ marginTop: 10 }}>
                <SectionComponent
                  sectionName={"Configurar Tela Pós Login"}
                  setIsOpen={setDropConfigScreen}
                  isOpen={dropConfigScreen}
                />
              </Row>

              <Collapse isOpen={dropConfigScreen}>
                <div className="form-check form-switch mt-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="checkScreen"
                    checked={enebleScreen}
                    onChange={(e) => setEnabelScreen(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="checkScreen">
                    Habilitar tela pós login
                  </label>
                </div>

                {enebleScreen && (
                  <>
                    <div className="mt-3">
                      <label className="form-label">URL da tela*</label>
                      <input
                        className="form-control"
                        value={formConfigScreen.url}
                        onChange={(e) =>
                          setFormConfigScreen({
                            ...formConfigScreen,
                            url: e.target.value,
                          })
                        }
                      />
                      {errosConfigScreen && errosConfigScreen.url && (
                        <span style={{ color: "red" }}>
                          {errosConfigScreen.url}
                        </span>
                      )}
                    </div>

                    <div className="mt-3">
                      <label className="form-label">Título da tela*</label>
                      <input
                        className="form-control"
                        value={formConfigScreen.title}
                        onChange={(e) =>
                          setFormConfigScreen({
                            ...formConfigScreen,
                            title: e.target.value,
                          })
                        }
                      />
                      {errosConfigScreen && errosConfigScreen.title && (
                        <span style={{ color: "red" }}>
                          {errosConfigScreen.title}
                        </span>
                      )}
                    </div>

                    <div
                      className="form-check form-switch mt-3"
                      style={{ display: "flex" }}
                    >
                      <div style={{ width: "50%" }}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="checkSkipScreen"
                          checked={formConfigScreen.skipScreen}
                          onChange={(e) =>
                            setFormConfigScreen({
                              ...formConfigScreen,
                              skipScreen: e.target.checked,
                            })
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="checkSkipScreen"
                        >
                          Permitir pular tela
                        </label>
                      </div>

                      <div>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="checkShowModal"
                          checked={formConfigScreen.showModal}
                          onChange={(e) =>
                            setFormConfigScreen({
                              ...formConfigScreen,
                              showModal: e.target.checked,
                            })
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="checkShowModal"
                        >
                          Exibir modal de confirmação
                        </label>
                      </div>
                    </div>

                    <div className="mt-3">
                      <label className="form-label">
                        Informe abaixo o(s) grupo(s) que não devem visualizar a
                        tela pós login
                      </label>
                      <Select
                        placeholder={"Selecione"}
                        isMulti={true}
                        value={formConfigScreen?.groups || []}
                        noOptionsMessage={() => "Nenhuma opção encontrada"}
                        onChange={(e) =>
                          setFormConfigScreen({
                            ...formConfigScreen,
                            groups: e,
                          })
                        }
                        options={[
                          {
                            options: [
                              ...groups.map((e) => {
                                return { label: e.name, value: e.id };
                              }),
                            ],
                          },
                        ]}
                        classNamePrefix="select2-selection"
                      />
                    </div>

                    <div className="form-check form-switch mt-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="checkFacial"
                        checked={formConfigScreen.facial}
                        onChange={(e) =>
                          setFormConfigScreen({
                            ...formConfigScreen,
                            facial: e.target.checked,
                          })
                        }
                      />
                      <label className="form-check-label" htmlFor="checkFacial">
                        Reconhecimento facial
                      </label>
                    </div>

                    {formConfigScreen && formConfigScreen.facial && (
                      <div className="mt-3">
                        <label className="form-label">
                          ID do evento no mice*
                        </label>
                        <input
                          className="form-control"
                          value={formConfigScreen.idMice}
                          onChange={(e) =>
                            setFormConfigScreen({
                              ...formConfigScreen,
                              idMice: e.target.value,
                            })
                          }
                        />
                        {errosConfigScreen && errosConfigScreen.idMice && (
                          <span style={{ color: "red" }}>
                            {errosConfigScreen.idMice}
                          </span>
                        )}
                      </div>
                    )}
                  </>
                )}
              </Collapse>

              <Row
                style={{
                  width: "100%",
                  margin: "auto",
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 20,
                }}
              >
                <Button
                  color="danger"
                  style={{ width: 80 }}
                  onClick={() => toggle()}
                >
                  Fechar
                </Button>

                <ButtonSpinner
                  isLoading={isLoading}
                  onClick={verifyForm}
                  title={"Salvar"}
                  marginLeft={10}
                />
              </Row>
            </ModalBody>
          </div>
        )}
      </Modal>
    </>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(ModalConfigApp);
